import { Box, Button, Container, Stack, Link as MuiLink } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import Logo from 'components/logo';
import LanguagePopover from 'layouts/dashboard/header/LanguagePopover';

const navItems = [
  { href: '#about-program', labelKey: 'landing.nav.about' },
  { href: '#account-guide', labelKey: 'landing.nav.toc' },
  { href: '#video-lessons', labelKey: 'landing.nav.video' }
];

export default function LandingHeader() {
  const { t } = useTranslation();

  return (
    <Box
      component="header"
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 10,
        bgcolor: 'rgba(255,255,255,0.92)',
        backdropFilter: 'blur(8px)',
        borderBottom: '1px solid',
        borderColor: 'divider',
        boxShadow: '0 4px 18px rgba(32, 101, 209, 0.08)'
      }}>
      <Container maxWidth="lg">
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ py: 1.5, gap: 2 }}>
          <Logo sx={{ maxWidth: { xs: 120, sm: 160 } }} />

          <Stack
            direction="row"
            alignItems="center"
            spacing={{ xs: 1, md: 3.5 }}
            sx={{ display: { xs: 'none', md: 'flex' }, flexGrow: 1, justifyContent: 'center' }}>
            {navItems.map((item) => (
              <MuiLink
                key={item.href}
                href={item.href}
                underline="none"
                color="text.primary"
                fontWeight={600}
                sx={{
                  fontSize: 14,
                  whiteSpace: 'nowrap',
                  px: 0.5,
                  '&:hover': { color: 'primary.main' }
                }}>
                {t(item.labelKey)}
              </MuiLink>
            ))}
          </Stack>

          <Stack direction="row" alignItems="center" spacing={2}>
            <LanguagePopover />
            <Button component={RouterLink} to="/open-account" variant="contained" color="primary" size="small">
              {t('Akkaunt ochish')}
            </Button>
            <Button component={RouterLink} to="/" variant="outlined" color="primary" size="small">
              {t('Kirish')}
            </Button>
          </Stack>
        </Stack>

        <Stack
          direction="row"
          spacing={3}
          sx={{ display: { xs: 'flex', md: 'none' }, pb: 1.5, overflowX: 'auto' }}>
          {navItems.map((item) => (
            <MuiLink
              key={item.href}
              href={item.href}
              underline="none"
              color="text.primary"
              fontWeight={600}
              sx={{ fontSize: 13, whiteSpace: 'nowrap' }}>
              {t(item.labelKey)}
            </MuiLink>
          ))}
        </Stack>
      </Container>
    </Box>
  );
}
